/**
 * Fait : le champ où l'on CHOISIT un mot de passe — c'est-à-dire un champ de
 *   mot de passe ordinaire, plus la BORNE de longueur annoncée avant la faute.
 *
 * Ne fait pas : il ne valide rien et ne juge pas la solidité de ce qui est
 *   tapé. La borne affichée vient du contrat partagé — le nombre n'est écrit
 *   nulle part deux fois. **Et il ne porte plus l'œil** : celui-ci vit dans le
 *   gabarit `Champ`, donc dans TOUS les champs de mot de passe du produit.
 *
 * CE QUI A CHANGÉ LE 2026-08-24, et pourquoi. Ce composant portait une case
 * « Afficher le mot de passe » sous le champ — et il n'était employé que sur
 * DEUX écrans sur quatre. La connexion et la suppression de compte avaient un
 * champ nu : impossible d'y relire ce qu'on tape. Charles l'a découvert en
 * essayant de se connecter, et a tranché : « tous les champs mot de passe
 * doivent avoir un œil à droite ». La leçon tient en une phrase — **une
 * protection qu'il faut penser à employer finit par manquer là où elle compte
 * le plus**, ici la porte d'entrée du produit. L'œil est donc descendu dans le
 * gabarit, où l'oubli devient impossible, et un contrôle mécanique refuse
 * désormais tout champ de mot de passe posé hors de lui.
 */

import { LONGUEUR_MINIMALE_MOT_DE_PASSE } from '@aymoai/shared';

import { Champ } from './Champ.tsx';

/** La borne, dite à la personne. Le nombre vient du contrat partagé. */
const AIDE =
  `${String(LONGUEUR_MINIMALE_MOT_DE_PASSE)} caractères au moins. ` +
  'Une phrase dont vous vous souvenez vaut mieux qu’un mot compliqué.';

export function ChampMotDePasse({
  libelle,
  name,
  autoComplete = 'new-password',
  value,
  onChange,
}: {
  readonly libelle: string;
  readonly name: string;
  readonly autoComplete?: string;
  readonly value: string;
  onChange: (valeur: string) => void;
}) {
  return (
    <Champ
      libelle={libelle}
      aide={AIDE}
      name={name}
      type="password"
      autoComplete={autoComplete}
      value={value}
      onChange={(evenement) => onChange(evenement.target.value)}
    />
  );
}
